import React from 'react'
import PropTypes from 'prop-types'
import { Modal, l } from '@manychat/manyui'

import { Permissions } from 'common/userRoles'

import TagHeader from './TagHeader'
import UserList from './UserList'

export default class UserListModal extends React.Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,

    users: PropTypes.array,
    loading: PropTypes.bool,
    hasMore: PropTypes.bool,
    onLoadMore: PropTypes.func,

    enableTagging: PropTypes.bool,
    taggedWith: PropTypes.any,
    onSelectTag: PropTypes.any,
  }

  getButtons = (subscriberEditingAllowed) => {
    const { enableTagging, taggedWith, onSelectTag } = this.props
    const { users } = this.props

    const headerButtons = []
    if (!subscriberEditingAllowed) {
      return headerButtons
    }

    if (enableTagging) {
      headerButtons.push(
        <TagHeader
          key="1"
          onSelect={onSelectTag}
          taggedWith={taggedWith}
          disabled={users.length === 0}
        />,
      )
    }

    return headerButtons
  }

  render() {
    const { isOpen, onClose, users, loading, hasMore, onLoadMore } = this.props

    return (
      <Permissions>
        {(permissions) => (
          <Modal
            open={isOpen}
            title={l.translate('Contacts')}
            onRequestClose={onClose}
            width={400}
            headerButtons={this.getButtons(permissions.SUBSCRIBER_EDITING)}
            scrollable
          >
            <UserList users={users} loading={loading} hasMore={hasMore} onLoadMore={onLoadMore} />
          </Modal>
        )}
      </Permissions>
    )
  }
}
